import {useApp} from "../../app.context";
import {useIntegrator} from "../../integrator.context";
import {UnitData} from "../../models/remoteConstants.model";
import AssetImage from "../../elements/assetImage.element";

function findMetadataId(state: any, uid: string): string | null {
    const collections = [state.unitAttributes, state.buildingAttributes, state.techActionAttributes, state.techPassiveAttributes];
    for (const collection of collections) {
        if (!collection) continue;
        const metadata = collection.find((m: any) => m.uid === uid);
        if (metadata) {
            return metadata.id;
        }
    }
    return null;
}

function UnitView() {
    const {state} = useIntegrator();
    const {unit, setUnit, setNotification, getLocalizationValue} = useApp();

    const unitData = state.units.find(u => u.id === unit) ?? {} as UnitData;

    function renderAttributes() {
        if (!unitData.attributes || unitData.attributes.length === 0) {
            return <></>;
        }

        return (
            <div className={'layout vertical gap'}>
                <div className={'layout horizontal wrap unit-attribute-row'}>
                    {unitData.attributes.map(attribute => {
                        const metaId = findMetadataId(state, attribute);
                        const descKey = metaId ? `${metaId}.description` : `${attribute}.description`;
                        return (
                            <button
                                key={attribute}
                                className={'button small unit-attribute-button'}
                                type="button"
                                onClick={() => setNotification({title: attribute, message: descKey, edit: true})}
                            >
                                {getLocalizationValue(attribute)}
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div className={'layout vertical overlay'} onClick={() => {
            setUnit(undefined);
        }}>
            <div className={'layout vertical gap box'} style={{padding: 10, gap: 20, width: 400}}
                 onClick={e => e.stopPropagation()}
            >
                <div className={'layout horizontal center stretch gap'}>
                    <div className={'layout horizontal'} style={{alignItems: 'center', gap: 10}}>
                        <AssetImage id={unitData.id} upload={false}/>
                        <p className={'text header'}>{getLocalizationValue(unitData.id)}</p>
                    </div>
                    <div className={'layout horizontal gap'} style={{alignItems: 'center'}}>
                        <p>{unitData.price}</p>
                        <AssetImage id={'gold'} size={30} background={'transparent'} upload={false}/>
                    </div>
                </div>
                <div className={'layout vertical gap'}>
                    <Property title={'HP'} value={unitData.properties.health}/>
                    <Property title={'Defense'} value={unitData.properties.defense}/>
                    <Property title={'Attack'} value={unitData.properties.attack}/>
                    <Property title={'Move'} value={unitData.properties.movementSpeed}/>
                    <Property title={'Range'} value={unitData.properties.range}/>
                </div>
                {renderAttributes()}
                <button onClick={() => setUnit(undefined)}>Close</button>
            </div>
        </div>
    )
}

function Property(props: { title: string, value: number }) {
    return (
        <div className={'layout horizontal stretch'}>
            <p style={{whiteSpace: 'pre-wrap'}}>{props.title}</p>
            <p style={{whiteSpace: 'pre-wrap'}}>{props.value}</p>
        </div>
    )
}

export default UnitView;